import Vue from 'vue';
import handlerFactory from './window-event-handler'

Vue.directive('scroll', handlerFactory('scroll'));
